import React from 'react'
import { useTranslation } from 'react-i18next'
import { AddressSwitcherProps } from '../../../../../../@types/props-types'
import { isWebView } from '../../../../../../utils/navigation'
import ToggleSwitch from '../../../../../common/inputs/toggleSwitch/ToggleSwitch'

const AddressSwitcher: React.FC<AddressSwitcherProps> = ({ isNational, setIsNational }) => {
  const { t } = useTranslation()
  const isMobile = isWebView()

  const handleToggleChange = React.useCallback(
    (_field: string, checked: boolean) => {
      setIsNational(!checked)
    },
    [setIsNational]
  )

  if (isMobile) {
    return (
      <div className='grid-item one-whole margin-bottom-l'>
        <ToggleSwitch
          id='address-switcher'
          alignment='maxSpread'
          propertyName='internationalAddress'
          label={<span>{t('wizard.screen.address.internationalProperty', 'Diese Immobilie ist im Ausland')}</span>}
          value={!isNational}
          onChange={handleToggleChange}
        />
      </div>
    )
  }

  // Desktop: render clickable text (original implementation)
  return (
    <div className='margin-bottom-l'>
      {isNational ? (
        <>
          <span className='margin-right-xs'>
            {t(
              'wizard.screen.internationalAddress.addressSwitchText',
              'Start with the location of your home and the four most important facts and figures.'
            )}
          </span>
          <button
            id='address-switcher-button'
            className='link-text padding-horizontal-none'
            onClick={() => setIsNational(false)}
          >
            {t('wizard.screen.internationalAddress.linkForNationalVariant', 'Your property is international?')}
          </button>
        </>
      ) : (
        <button
          id='address-switcher-button'
          className='link-text padding-horizontal-none'
          onClick={() => setIsNational(true)}
        >
          {t('wizard.screen.internationalAddress.linkForInternationalVariant', 'Your property is in germany?')}
        </button>
      )}
    </div>
  )
}

export default AddressSwitcher
